export default __webpack_public_path__ + "static/media/37.bbdbff96.jpg";